export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('table_label_shelves_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_shelves_goodsName') || '产品名称',
    field: 'goodsName',
    minWidth: 260,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  // {
  //   title: that.$l('INDEX.table_label_goodsSize') || '产品尺寸',
  //   field: 'goodsSize',
  //   minWidth: 200,
  //   headerAlign: 'left',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   slots: { default: 'displayColor' },
  // },
  {
    title: that.$l('table_label_shelves_channelItemNo') || '渠道ITEM号',
    field: 'channelItemNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 50,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_channelSkuNo') || '渠道款号',
    field: 'channelSkuNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 50,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_channelEanNo') || '渠道UPC',
    field: 'channelEanNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 50,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_salesPrice') || '订单结算价格',
    field: 'salesPrice',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 2,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_actualPrice') || '实际结算价格',
    field: 'actualPrice',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 2,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_retailPrice') || '终端零售价',
    field: 'retailPrice',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 2,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_sellableEachQty') || '最小出货入数',
    field: 'sellableEachQty',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 1,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_sellableEachUnit') || '最小出货单位',
    field: 'sellableEachUnit',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'sellableEachUnit' },
        url: '/master/common/dict/biz',
        filterable: true,
        clearable: true,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_whSkuNo') || '仓库SKU号',
    field: 'whSkuNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 50,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_eachGtinNo') || '渠道产品GTIN号',
    field: 'eachGtinNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 50,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_innerPackGtinNo') || '渠道内包装GTIN号',
    field: 'innerPackGtinNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 50,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_caseGtinNo') || '渠道箱包装GTIN号',
    field: 'caseGtinNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 50,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shelves_brand') || 'SKU品牌',
    field: 'brandCode',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    editRender: {
      name: 'dict-select',
      props: {
        url: '/master/common/dict/brandSelect',
        filterable: true,
        clearable: true,
        size: 'mini',
      },
    },
  },
  // {
  //   title: that.$l('table_label_salesGoodsName') || '店铺售卖名称',
  //   field: 'salesGoodsName',
  //   minWidth: 250,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   editRender: {
  //     name: 'ElInput',
  //     props: {
  //       placeholder: '请输入',
  //       style: 'width:100%',
  //       maxlength: 500,
  //       size: 'mini',
  //     },
  //   },
  // },
  {
    title: that.$l('table_label_shelves_salesTitle') || '渠道售卖标题',
    field: 'salesTitle',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 1000,
        size: 'mini',
      },
    },
  },
  // {
  //   title: that.$l('table_label_salesCurrencyUnit') || '卖价货币单位',
  //   field: 'salesCurrencyUnit',
  //   width: 160,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   editRender: {
  //     name: 'dict-select',
  //     props: {
  //       body: { dictType: 'currencyUnit' },
  //       url: '/master/common/dict/biz',
  //       filterable: true,
  //       clearable: true,
  //       size: 'mini',
  //     },
  //   },
  // },
  // {
  //   title: that.$l('INDEX.form_label_ecomWarehouseCode') || '发货仓库',
  //   field: 'ecomWarehouseCode',
  //   width: 120,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   editRender: {
  //     name: 'dict-select',
  //     props: {
  //       url: '/ecom/warehouse/warehouse/select/all',
  //       filterable: true,
  //       clearable: true,
  //       size: 'mini',
  //     },
  //   },
  // },
]
